import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import PropTypes from 'prop-types';
import React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var Spacer = /*#__PURE__*/function (_React$PureComponent) {
  function Spacer() {
    _classCallCheck(this, Spacer);
    return _callSuper(this, Spacer, arguments);
  }
  _inherits(Spacer, _React$PureComponent);
  return _createClass(Spacer, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/_jsx("div", {
        style: {
          height: this.props.height,
          flexShrink: 0
        }
      });
    }
  }]);
}(React.PureComponent);
_defineProperty(Spacer, "propTypes", {
  height: PropTypes.number.isRequired
});
export default Spacer;